import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login'
import cat from '@/views/cat'
import cart from '@/views/cart'
import paysuccess from '@/views/paysuccess'
import orderlist from '@/views/order-list'
import orderview from '@/views/order-view'
import address from '@/views/address'
import resetpwd from '@/views/resetpwd'
import pay from '@/views/pay'
import ordermodify from '@/views/order-modify'
import Page404 from '@/views/Page404'
Vue.use(Router)

export default new Router({
	// mode: 'history',  //去掉url中的#
	routes: [{
			path: '/login',
			name: 'login',
			component: login,
			meta: {
                title: '登录',
                keepAlive: true, // 需要被缓存
            }
		},{
			path: '/',
			component: login,
			meta: {
                title: '登录',
                keepAlive: true, // 需要被缓存
            }
		}, {
			path: '/cat',
			name: 'cat',
			component: cat,
			meta: {
			    title: '商品分类'
			}
		}, {
			path: '/cart',
			name: 'cart',
			component: cart,
			meta: {
			    title: '购物车'
			}
		},
		{
			path: '/order-list',
			name: 'orderlist',
			component: orderlist,
			meta: {
			    title: '订单列表'
			}
		},
		{
			path: '/order-view',
			name: 'orderview',
			component: orderview,
			meta: {
			    title: '订单详情'
			}
		}, {
			path: '/address',
			name: 'address',
			component: address,
			meta: {
			    title: '收货地址'
			}
		}, {
			path: '/resetpwd',
			name: 'resetpwd',
			component: resetpwd,
			meta: {
			    title: '修改密码'
			}
		},
		{
			path: '/paysuccess',
			name: 'paysuccess',
			component: paysuccess,
			meta: {
			    title: '订单提交成功'
			}
		}, {
			path: '/pay',
			name: 'pay',
			component: pay,
			meta: {
			    title: '提交订单'
			}
		},{
			path: '/order-modify',
			name: 'ordermodify',
			component: ordermodify,
			meta: {
			    title: '修改订单'
			}
		},
		{
          path: '*', // 404 页面
          component: () => import('@/views/Page404') // 或者使用component也可以的

        },

	]
})



// WEBPACK FOOTER //
// ./src/router/index.js